const TabButton = ({ tab, label, activeTab, handleTabClick }) => {
  const isActive = activeTab === tab;
  const buttonStyle = {
    width: "33.33%",
    padding: "10px",
    backgroundColor: "aliceblue",
    ...(isActive && {
      color: "#1675e0",
      borderBottom: "2px solid #1675e0",
      backgroundColor: "aliceblue",
    }),
  };

  return (
    <button
      onClick={() => handleTabClick(tab)}
      className={`tab-button ${isActive ? "active" : ""}`}
      style={buttonStyle}
    >
      {label}
    </button>
  );
};

export default TabButton;
